import { createFileRoute } from '@tanstack/react-router';

import AuthActionPage from '~/pages/auth/action';

export const Route = createFileRoute('/auth/action')({
  component: AuthActionPage,
});
